import { MessageCircle } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import DesignCTA from "@/components/DesignCTA";
import { ACTIVEWEAR_GROUPS, IMAGES, SPORTS, waLink } from "@/data/content";

const ACTIVE_WA = waLink(SPORTS.find((s) => s.id === "activewear").msg);

export default function Activewear() {
  return (
    <>
      <PageHero
        testId="activewear-hero"
        eyebrow="Product Range"
        title="Activewear & Apparel"
        sub="Performance and lifestyle apparel — shirts, polos, hoodies, jackets, tracksuits, shorts and joggers — produced with your branding."
        img={IMAGES.jackets}
      />

      <section className="py-14 md:py-20" data-testid="activewear-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {ACTIVEWEAR_GROUPS.map((g, i) => (
              <Reveal key={g.id} delay={i * 0.05}>
                <div
                  id={g.id}
                  data-testid={`active-card-${g.id}`}
                  className="scroll-mt-28 group bg-white rounded-lg border border-slate-200 overflow-hidden hover:border-ice/60 hover:shadow-lg transition-all duration-300"
                >
                  <div className="h-52 overflow-hidden">
                    <img src={g.img} alt={g.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                  </div>
                  <div className="p-6">
                    <h2 className="font-display font-semibold uppercase text-2xl text-navy">{g.name}</h2>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{g.desc}</p>
                    <a
                      href={ACTIVE_WA}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`active-quote-${g.id}`}
                      className="mt-5 link-accent"
                    >
                      <MessageCircle size={15} />
                      Discuss on WhatsApp
                    </a>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <DesignCTA />
    </>
  );
}
